'use client';

import { OpsHomeRedirect } from '@/platform/servicedesk/OpsHomeRedirect';

/** Ops static export home — swapped in by scripts/build-ops.mjs during communio-ops CI/deploy. */
export default function HomePage() {
  return <OpsHomeRedirect />;
}
